<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="formInline" inline style="text-align: center;margin-top: 10px;color: black;">
			<RadioGroup @on-change="radioChange" size='large' v-model="Methodtype">
				<Radio label="新增菜单">
					<Icon type="ios-add-circle" />
					<span>新增菜单</span>
				</Radio>
				<Radio label="修改菜单">
					<Icon type="ios-add-circle" />
					<span>修改菜单</span>
				</Radio>
				<Radio label="删除菜单">
					<Icon type="md-trash" />
					<span>删除菜单</span>
				</Radio>
			</RadioGroup>
			<Button type="primary" @click="assignMenuWidgets" :disabled="selectedMenuId == 0">分配控件</Button>
		</Form>
		<div style="float: left; overflow-y: auto;">
			<Tree style="text-align: left;" @on-select-change="getSelect" :data="Menus" ref="tree"></Tree>
		</div>
		<div>
			<Card style="float: right;margin-right: 30%;margin-top: 10%;width: 40%;">
				<p style="color: #000000;" slot="title">操作:{{Methodtype}}-------->{{selectTree}}</p>
				<p style="color: #000000;margin-bottom: 0.15625rem;">点击左侧菜单树选择编辑的菜单</p>
				<Form :rules="ruleInline" v-if="Methodtype=='新增菜单'||Methodtype=='删除菜单'||Methodtype=='修改菜单'"
					label-position="right" ref="menuForm" :model="menuInfo" :label-width="90">
					<Row :gutter="24" style="margin-bottom: 10px;">
						<Col span=12>
						<FormItem label="菜单名称" prop="title">
							<Input :disabled="canInput" v-model="menuInfo.title" placeholder="菜单名称"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem label="菜单描述" prop="Desc">
							<Input :disabled="canInput" v-model="menuInfo.Desc" placeholder="菜单描述"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24" style="margin-bottom: 10px;">
						<Col span=12>
						<FormItem label="菜单Url" prop="Url">
							<Input :disabled="canInput" v-model="menuInfo.Url" placeholder="菜单Url"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem label="菜单Action" prop="AspAction">
							<Input :disabled="canInput" v-model="menuInfo.AspAction" placeholder="菜单Action"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24">
						<Col span=12>
						<FormItem label="菜单Controller" prop="AspController">
							<Input :disabled="canInput" v-model="menuInfo.AspController"
								placeholder="菜单Controller"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem label="顺序号" prop="Sortorder">
							<Input :disabled="canInput" v-model="menuInfo.Sortorder" placeholder="顺序号"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24" style="margin-bottom: 10px;">
						<Col span=12>
						<FormItem label="图标" prop="Icon">
							<Input :disabled="canInput" v-model="menuInfo.Icon" placeholder="图标"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem label="菜单展示名称" prop="DisplayName">
							<Input :disabled="canInput" v-model="menuInfo.DisplayName" placeholder="菜单名称"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="24" style="margin-bottom: 10px;">
						<Col span=12>
						<FormItem label="父级菜单名" prop="TopName">
							<Input :disabled="true" v-model="menuInfo.topName" placeholder="父级菜单名"></Input>
						</FormItem>
						</Col>
						<Col span=12>
						<FormItem label="上一级标识" prop="ParentId">
							<Input :disabled="true" v-model="menuInfo.ParentId" placeholder="上一级标识"></Input>
						</FormItem>
						</Col>
					</Row>
					<div v-if='Methodtype=="新增菜单"'>
						<Button type="success" long size="large" @click="modalOk('add')">添加</Button>
					</div>
					<div v-if='Methodtype=="修改菜单"'>
						<Button type="warning" long size="large" @click="modalOk('up')">修改菜单</Button>
					</div>
					<div v-if='Methodtype=="删除菜单"'>
						<Button type="error" long size="large" @click="modalOk('del')">添加</Button>
					</div>
				</Form>
			</Card>
		</div>
		<Modal v-model="modalAssign" :title="'分配菜单控件[' + selectTree + ']'" :loading="true" @on-ok="asyncOK">
			<Transfer :data="dataWidgets" :target-keys="targetWidgets" :render-format="renderWidgets"
				@on-change="handleChangeWidgets" :titles="['未分配', '已分配']">
			</Transfer>
		</Modal>
	</div>
</template>

<script>
	import webapi from '../../../webapi';
	export default {
		data() {
			return {
				BreadcrumbList: ['系统管理', '>>', '菜单管理'],
				Menus: [],
				canInput: false,
				menuInfo: {
					Id: 0,
					title: '',
					Desc: '',
					Url: '',
					AspAction: '',
					AspController: '',
					Sortorder: 0,
					Icon: '',
					DisplayName: '',
					topName: '',
					ParentId: '',
					children: '',
				},
				dataWidgets: [],
				targetWidgets: [],
				modalAssign: false,
				ruleInline: {
					// Name: [{
					// 	validator: validateOpId,
					// 	trigger: 'blur',
					// }],
					title: [{
						required: true,
						message: 'title',
						trigger: 'blur'
					}],
					DisplayName: [{
						required: true,
						message: 'DisplayName',
						trigger: 'blur'
					}],
				},
				Methodtype: '新增菜单',
				selectTree: '',
				selectedMenuId: 0,
			}
		},
		mounted() {
			this.getMenus();

			const _this = this;
			this.$axios.post(webapi.base_api_url + '/System/GetSysWidgets', {
				pageSize: 10000
			}).then(res => {
				if (res.status == 200 && res.data.Code == 0) {
					_this.dataWidgets = res.data.Data.List.map(obj => {
						return {
							key: obj.Id,
							label: obj.Display,
							description: obj.Desc
						}
					});
				}
			});

		},
		methods: {
			getMenus: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + "/System/GetSysMenus", {}).then(res => {
					if (res.data.Code == 0) {
						// this.dealMenu(res.data.Data.List)
						_this.Menus = [{
							id: 0,
							title: '系统菜单',
							children: res.data.Data.List,
							expand: true,
						}];
					}
				})
			},
			// dealMenu: function(Menu) {
			// 	let menuTree = []
			// 	Menu.map(function(item) {
			// 		if (item.length != 0) {
			// 			let Father = {
			// 				title: item[0].topName,
			// 				children: [],
			// 				expand: true,
			// 				// disabled: true
			// 			};
			// 			item.map(function(item2) {
			// 				Father.children.push(item2)
			// 			})
			// 			menuTree.push(Father)
			// 		}
			// 	})
			// 	this.Menus = menuTree
			// 	console.log(JSON.stringify(menuTree))
			// },
			radioChange: function() {
				const _this = this
				let a = _this.Methodtype
				let select = _this.$refs.tree.getSelectedNodes()
				// if (select.length != 0) {
				// 	select[0].selected = false
				// }
				_this.menuInfo = {
					Id: 0,
					title: '',
					Desc: '',
					Url: '',
					AspAction: '',
					AspController: '',
					Sortorder: 0,
					Icon: '',
					DisplayName: '',
					TopName: '',
					ParentId: '',
					children: '',
				}
				// _this.selectTree = ''
				switch (a) {
					case "修改菜单":
						_this.canInput = false
						break;
					case "删除菜单":
						_this.canInput = true
						break;
					case "新增菜单":
						_this.canInput = false
						break;
					default:
						break;
				}
			},
			getSelect: function(arr, item) {
				const _this = this
				if (item.children.length == 0) {
					_this.selectedMenuId = item.Id;
				} else {
					_this.selectedMenuId = 0;
				}

				if (arr.length == 0) {
					_this.$refs.menuForm.resetFields()
				} else {
					let a = _this.Methodtype
					switch (a) {
						case "修改菜单":
							_this.menuInfo = Object.assign({}, item)
							_this.selectTree = item.DisplayName
							_this.canInput = false
							break;
						case "删除菜单":
							_this.selectTree = item.DisplayName
							_this.menuInfo = Object.assign({}, item)
							_this.canInput = true
							break;
						case "新增菜单":
							_this.selectTree = '上级菜单:' + item.DisplayName
							//_this.menuInfo=Object.assign({},item)
							_this.menuInfo.ParentId = item.Id
							_this.menuInfo.topName = item.title
							_this.canInput = false
							break;
						default:
							this.$Message.error("修改或删除菜单时可选择")
							item.selected = false
							break;
					}
				}
			},
			//model操作
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case 'distribute':
						this.$Message.error("暂无")
						break;
					case 'add':
						this.AddSysMenu()
						break;
					case 'del':
						this.$Message.error("暂无")
						break;
					case 'up':
						this.AddSysMenu()
						break;
					default:
						break;
				}
			},
			AddSysMenu: function(type) {
				const _this = this;
				_this.$refs.menuForm.validate((valid) => {
					console.log("菜单" + type + "----" + valid)
					if (valid) {
						let parms = _this.menuInfo
						_this.$axios.post(webapi.base_api_url + "/System/AddSysMenu", parms, {}).then(res => {
							console.log("新增菜单")
							console.log(res.data)
							if (res.data.Code == 0) {
								this.$Message.success('添加成功');
								_this.getMenus();
								_this.radioChange()
								_this.modalOk("cancle")
							} else {
								this.$Message.success(res.data.Msg + "---" + res.data.Data);
							}
						})
					}
				})
			},
			assignMenuWidgets: function() {
				const _this = this;
				// this.$axios.post(webapi.base_api_url + '/System/GetSysWidgets', {
				// 	pageSize: 10000
				// }).then(res => {
				// 	if (res.status == 200 && res.data.Code == 0) {
				// 		_this.dataWidgets = res.data.Data.List;
				// 	}
				// });
				this.$axios.post(webapi.base_api_url + '/System/GetWidgetsByMenuId', {
					menuId: _this.selectedMenuId
				}).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.targetWidgets = res.data.Data.List.map(obj => obj.Id);
					}
				});
				// this.$Message.success(this.selectedMenuId + '');
				this.modalAssign = true;
			},
			renderWidgets: function(item) {
				return item.label;
			},
			handleChangeWidgets: function(newTargetKeys, direction, moveKeys) {
				this.targetWidgets = newTargetKeys;
			},
			asyncOK: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + '/System/AssignMenuWidgets', {
					menuId: this.selectedMenuId,
					widgets: this.targetWidgets
				}).then(res => {
					if (res.status == 200 && res.data.Code == 0) {
						_this.$Message.success('分配成功');
						_this.modalAssign = false;
					} else {
						_this.$Message.error('分配失败');
					}
				});
			}
		}
	}
</script>

<style>
	.ivu-tree-title-selected,
	.ivu-tree-title-selected:hover {
		background-color: #00FF00;
		color: white;
		font-weight: bold;
	}
</style>
